
define('text!modules/targeting/location/templates/search_results.html',[],function () { return '{{#results}}\n    {{>gridSubItem}}\n{{/results}}\n';});

